import React, { forwardRef, useCallback, useMemo, useRef, useState } from "react";
import classnames from  "classnames";

import IconView from "../IconView/IconView";
import EgwWebFont from "../../assets/EgwWebFont";
import useRefData from "../../hooks/useRefData";
import { handleReactRef } from "../../utils/react";

import styles from "./SwipeArrows.module.scss";

const SwipeArrows = forwardRef(({
  className,
  isCanShowArrowLeft, isCanShowArrowRight,
  onClickArrowLeft, onClickArrowRight,
  isUseLogicOfLeavingHoveredShown,
}, ref) => {
  const refIdTimeoutHideArrowsAfterScrolled = useRef(undefined);

  const [isShowArrowsAfterScrolled, setIsShowArrowsAfterScrolled] = useState(false);

  const refData = useRefData({isShowArrowsAfterScrolled});

  const _autoHideArrowsAfterScrolled = useCallback(() => {
    refIdTimeoutHideArrowsAfterScrolled.current = setTimeout(() => {
      setIsShowArrowsAfterScrolled(false);
      refIdTimeoutHideArrowsAfterScrolled.current = undefined;
    }, 2500);
  }, []);

  const _cancelHideArrowsAfterScrolled = useCallback(() => {
    if (refIdTimeoutHideArrowsAfterScrolled.current !== undefined) {
      clearTimeout(refIdTimeoutHideArrowsAfterScrolled.current);
      refIdTimeoutHideArrowsAfterScrolled.current = undefined;
    }
  }, []);

  const showArrowsWithAutoHide = useCallback(() => {
    _cancelHideArrowsAfterScrolled();

    if (!refData.current.isShowArrowsAfterScrolled) {
      setIsShowArrowsAfterScrolled(true);
    }

    _autoHideArrowsAfterScrolled();
  }, [_cancelHideArrowsAfterScrolled, _autoHideArrowsAfterScrolled]);

  const interfaceRef = useMemo(() => {
    return {
      showArrowsWithAutoHide,
    };
  }, [
    showArrowsWithAutoHide,
  ]);

  handleReactRef(ref, interfaceRef);

  const [isHoveredArrowLeft, setIsHoveredArrowLeft] = useState(false);
  const [isHoveredArrowRight, setIsHoveredArrowRight] = useState(false);

  const handleMouseEnterArrow = useCallback((isArrowRight) => {
    if (!isUseLogicOfLeavingHoveredShown) {
      return;
    }
    if (isArrowRight) {
      setIsHoveredArrowRight(true);
    } else {
      setIsHoveredArrowLeft(true);
    }
  }, [isUseLogicOfLeavingHoveredShown]);
  const handleMouseLeaveArrow = useCallback((isArrowRight) => {
    if (!isUseLogicOfLeavingHoveredShown) {
      return;
    }
    if (isArrowRight) {
      setIsHoveredArrowRight(false);
    } else {
      setIsHoveredArrowLeft(false);
    }
  }, [isUseLogicOfLeavingHoveredShown]);

  return (
    <div className={classnames(styles["swipe-arrows"], className)}>
      <div className={styles["inner"]}>
        <div
          className={classnames(styles["arrow"], styles["prev"], {
            [styles["shown"]]: isShowArrowsAfterScrolled
            && isCanShowArrowLeft || isHoveredArrowLeft,
          })}
          onClick={onClickArrowLeft}
          onMouseEnter={() => handleMouseEnterArrow(false)}
          onMouseLeave={() => handleMouseLeaveArrow(false)}
        >
          <IconView icon={EgwWebFont["chevron-left"]} />
        </div>
        <div
          className={classnames(styles["arrow"], styles["next"], {
            [styles["shown"]]: isShowArrowsAfterScrolled
            && isCanShowArrowRight || isHoveredArrowRight,
          })}
          onClick={onClickArrowRight}
          onMouseEnter={() => handleMouseEnterArrow(true)}
          onMouseLeave={() => handleMouseLeaveArrow(true)}
        >
          <IconView icon={EgwWebFont["chevron-left"]} />
        </div>
      </div>
    </div>
  );
});

export default SwipeArrows;
